import { render } from "./notificationCC.vue?vue&type=template&id=020e4f6a"
import script from "./notificationCC.vue?vue&type=script&lang=js"
export * from "./notificationCC.vue?vue&type=script&lang=js"

import "./notificationCC.vue?vue&type=style&index=0&id=020e4f6a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__